export const About = () => {
  return (
    <section id="about" className="container py-24 sm:py-32">
      <div className="rounded-lg border bg-primary-foreground py-12">
        <div className="flex flex-col-reverse gap-8 px-6 md:flex-row md:gap-12">
          <div className="bg-green-0 flex flex-col justify-between">
            <div className="pb-6">
              <h2 className="text-3xl font-bold md:text-4xl">
                <span className="bg-gradient-to-b from-primary/60 to-primary bg-clip-text text-transparent">
                  About{' '}
                </span>
                Eclipse Fitness
              </h2>
              <p className="mt-4 text-xl text-muted-foreground">
                At Eclipse Fitness, we believe that everyone deserves access to
                the tools and guidance necessary to reach their health and
                wellness goals. Our facility boasts a variety of equipment,
                group fitness classes, and personalized training programs
                tailored to your specific needs. Whether you're a seasoned
                athlete or just beginning your fitness journey, we're here to
                help you create and foster a healthy and active lifestyle.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
